enum MapLayerType {
  CurrentRoadLayer = "CurrentRoadLayer",
  NetworkLayer = "NetworkLayer",
  ThematicLayer = "ThematicLayer",
  GeospatialLayer = "GeospatialLayer",
}

export default MapLayerType;
